// Code modified and adapted from public domain code written by drow <drow@bin.sh>
// The modified code is released under the MIT License
type Chain = {[key:string]: {[key:string]: number}};

export default class Markov {
    static generate(list: string[], count: number) {
        let chain = Markov.markov_chain(list);
        if (chain) {
            let list = [];
            let i; for (i = 0; i < count; i++) {
                list.push(Markov.markov_name(chain));
            }
            return list;
        }
        else {
            console.warn('Markov generator has 0 results');
            return [] as string[];
        }
    }

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // get markov chain by type
    static markov_chain(list: string[]) {
        if (list.length > 0) {
            let chain = Markov.construct_chain(list);
            if (chain) {
                return chain;
            }
        }

        return false;
    }

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // construct markov chain from list of names
    static construct_chain(list: string[]) {
        let chain = {};

        let i; for (i = 0; i < list.length; i++) {
            let names = list[i].split(/\s+/);
            chain = Markov.incr_chain(chain, 'parts', names.length);

            let j; for (j = 0; j < names.length; j++) {
                let name = names[j];
                chain = Markov.incr_chain(chain, 'name_len', name.length);

                let c = name.substr(0, 1);
                chain = Markov.incr_chain(chain, 'initial', c);

                let string = name.substr(1);
                let last_c = c;

                while (string.length > 0) {
                    let c = string.substr(0, 1);
                    chain = Markov.incr_chain(chain, last_c, c);

                    string = string.substr(1);
                    last_c = c;
                }
            }
        }

        return Markov.scale_chain(chain);
    }

    static incr_chain(chain: Chain, key: string, index: number|string) {
        if (chain[key]) {
            if (chain[key][index]) {
                chain[key][index]++;
            } else {
                chain[key][index] = 1;
            }
        }
        else {
            chain[key] = {};
            chain[key][index] = 1;
        }

        return chain;
    }

    static scale_chain(chain: Chain) {
        let table_len = {} as {[key:string]: number};

        Object.keys(chain).forEach(key => {
            table_len[key] = 0;

            Object.keys(chain[key]).forEach(token => {
                let count = chain[key][token];
                let weighted = Math.floor(Math.pow(count, 1.3));

                chain[key][token] = weighted;
                table_len[key] += weighted;
            });
        });

        chain['table_len'] = table_len;
        return chain;
    }

    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    // construct name from markov chain
    static markov_name(chain: Chain) {
        let parts = Markov.select_link(chain, 'parts') as any;
        let names = [];

        let i; for (i = 0; i < parts; i++) {
            let name_len = Markov.select_link(chain, 'name_len') as any;
            let c = Markov.select_link(chain, 'initial') as string;
            let name = c;
            let last_c = c;

            while (name.length < name_len) {
                c = Markov.select_link(chain, last_c) as any;
                if (!c) break;

                name += c;
                last_c = c;
            }
            names.push(name);
        }

        return names.join(' ');
    }

    static select_link(chain: Chain, key: string) {
        let len = chain['table_len'][key];
        if (!len) return false;
        let idx = Math.floor(Math.random() * len);
        let tokens = Object.keys(chain[key]);
        let acc = 0;

        let i; for (i = 0; i < tokens.length; i++) {
            let token = tokens[i];

            acc += chain[key][token];
            if (acc > idx) return token;
        }

        return false;
    }
}